import React from "react";
import "../Gallery.css";

const Premium = ({ activeSubTab = "premium", onTabChange = () => {}, onCategoryClick = () => {} }) => {
  const categories = [
    {
      id: 1,
      number: "0 - 3",
      title: "All photos from",
      subtitle: "0 to 3 days old",
      days: 3
    },
    {
      id: 2,
      number: "5",
      title: "All photos from",
      subtitle: "5 days old",
      days: 5
    },
    {
      id: 3,
      number: "8",
      title: "All photos from",
      subtitle: "8 days old",
      days: 8
    }
  ];

  return (
    <div className="container gallery-container">
      {/* Sub Tabs */}
      <div className="gallery-sub-tabs">
        <button
          className={`sub-tab-item ${activeSubTab === "premium" ? "active" : ""}`}
          onClick={() => {
            if (typeof onTabChange === 'function') {
                onTabChange("premium");
            } else {
                console.error("onTabChange is not a function in Premium", onTabChange);
            }
          }}
        >
          Premium
        </button>
        <button
          className={`sub-tab-item ${activeSubTab === "standard" ? "active" : ""}`}
          onClick={() => {
            if (typeof onTabChange === 'function') {
                onTabChange("standard");
            } else {
                console.error("onTabChange is not a function in Premium", onTabChange);
            }
          }}
        >
          Standard
        </button>
      </div>

      {/* Categories Wrapper */}
      <div className="premium-category-wrapper">
        <div className="category-cards-grid">
          {categories.map((cat) => (
            <div key={cat.id} className="category-card" onClick={() => onCategoryClick(cat.days)}>
              <div className="category-card-number">{cat.number}</div>
              <div className="category-card-title">{cat.title}</div>
              <div className="category-card-subtitle">{cat.subtitle}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Premium;